import { render, staticRenderFns } from "./UserRoleTeams.vue?vue&type=template&id=1a409d18&"
import script from "./UserRoleTeams.vue?vue&type=script&lang=ts&"
export * from "./UserRoleTeams.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports